import { ReactNode } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SuccessTickIconBanner } from '../../../../components/Icons/SuccessTickIcon';

const NumberContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  width: '2rem',
  height: '2rem',
  flexShrink: 0,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: selected ? theme.palette.colors.turquoise : theme.palette.monochrome.monoChrome2,
  fontSize: '0.875rem',
}));

interface FormSectionProps {
  number: number;
  title: string;
  description: string;
  children: ReactNode;
  selected?: boolean;
}

function FormSection({ number, title, description, children, selected = false }: FormSectionProps) {
  const theme = useTheme();

  return (
    <Box sx={{ padding: '2.5rem' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem' }}>
        <NumberContainer selected={selected}>{selected ? <SuccessTickIconBanner /> : number}</NumberContainer>
        <Box>
          <Typography sx={{ fontSize: '1.25rem', fontWeight: 400 }}>{title}</Typography>
          <Typography sx={{ fontSize: '1.125rem', color: theme.palette.monochrome.monoChrome4 }}>
            {description}
          </Typography>
        </Box>
      </Box>
      {children}
    </Box>
  );
}

export default FormSection;
